import { ComputedRef, Ref, ref, WritableComputedRef } from 'vue';

export default (custom?: Ref<boolean> | WritableComputedRef<boolean>) => {
  const loading = custom || ref(false);
  const requestOptions = {
    startLoading: () => {
      loading.value = true;
    },
    finishLoading: () => {
      loading.value = false;
    },
  };

  return {
    loading,
    requestOptions,
  };
};
